export default __webpack_public_path__ + "static/media/login-background.0cef50a1.jpg";